"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStep = updateStep;
const dist_1 = require("../../fs/dist");
async function updateStep(input, deps) {
    const weaveId = await (0, dist_1.resolveWeaveSlugForPlan)(deps.loomRoot, input.planUlid);
    const weave = await deps.loadWeave(deps.loomRoot, weaveId);
    const plan = weave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    if (!plan) {
        throw new Error(`Plan '${input.planUlid}' not found in weave '${weaveId}'`);
    }
    const patch = {
        ...(input.patch.description !== undefined ? { description: input.patch.description } : {}),
        ...(input.patch.files !== undefined ? { files_touched: input.patch.files } : {}),
        ...(input.patch.blockedBy !== undefined ? { blockedBy: input.patch.blockedBy } : {}),
        ...(input.patch.satisfies !== undefined ? { satisfies: input.patch.satisfies } : {}),
    };
    if (Object.keys(patch).length === 0) {
        throw new Error('Nothing to update — provide at least one of description, files, blockedBy, satisfies. (title/detail are body prose — use loom_patch_doc.)');
    }
    await deps.runEvent(weaveId, { type: 'UPDATE_STEP', planId: input.planUlid, stepId: input.stepId, patch });
    const updatedWeave = await deps.loadWeave(deps.loomRoot, weaveId);
    const updatedPlan = updatedWeave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    return { plan: updatedPlan };
}
